import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=33470cf0&scoped=true"
import script from "./BackTop.vue?vue&type=script&lang=js"
export * from "./BackTop.vue?vue&type=script&lang=js"
import style0 from "./BackTop.vue?vue&type=style&index=0&id=33470cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33470cf0",
  null
  
)

export default component.exports